<template>
  <a-drawer
    :maskClosable="false"
    width="50%"
    :label-col="4"
    :wrapper-col="14"
    :visible="open"
    @close="onClose"
    :destroyOnClose="true"
  >
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <LoadingPop width="50%" v-if="showLoading" ref="LoadingPop" @ok="showLoading = false" />
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="参数名称" prop="configName">
        <a-input v-model="form.configName" placeholder="请输入" />
      </a-form-model-item>
      <a-form-model-item label="参数分组" prop="configGroup">
        <a-input v-model="form.configGroup" placeholder="请输入" />
      </a-form-model-item>
      <a-form-model-item label="参数键名" prop="configKey">
        <a-input v-model="form.configKey" placeholder="请输入" />
      </a-form-model-item>
      <a-form-model-item label="参数类型" prop="configType">
        <a-radio-group v-model="form.configType" button-style="solid">
          <a-radio-button v-for="(d, index) in configTypeOptions" :key="index" :value="d.value">
            {{ d.label }}
          </a-radio-button>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item label="参数键值" prop="configValue">
        <a-input v-model="form.configValue" placeholder="请输入" v-if="form.configType === '1'" />
        <a-textarea v-model="form.configValue" placeholder="请输入" v-if="form.configType === '2'" />
        <wang-editor-v5 v-model="form.configValue" v-if="form.configType === '3' && open" :height="400" />
        <div v-if="form.configType === '4'" class="json-key-value-container">
          <div v-for="(item, index) in jsonKeyValuePairs" :key="index" class="json-key-value-item">
            <a-input v-model="item.key" placeholder="请输入键名" class="json-key-input" />
            <a-input v-model="item.value" placeholder="请输入键值" class="json-value-input" />
            <a-button
              type="danger"
              icon="delete"
              @click="removeKeyValuePair(index)"
              :disabled="jsonKeyValuePairs.length === 1"
            >
              删除
            </a-button>
          </div>
          <a-button type="dashed" icon="plus" @click="addKeyValuePair" style="width: 100%; margin-top: 8px">
            添加键值对
          </a-button>
        </div>
      </a-form-model-item>
      <a-form-model-item label="系统内置" prop="configSystem">
        <a-radio-group v-model="form.configSystem" button-style="solid">
          <a-radio-button v-for="(d, index) in typeOptions" :key="index" :value="d.value">
            {{ d.label }}
          </a-radio-button>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item label="备注" prop="remark">
        <a-input v-model="form.remark" placeholder="请输入备注" type="textarea" allow-clear />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm"> 保存 </a-button>
          <a-button type="dashed" @click="cancel"> 取消 </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<style scoped>
.json-key-value-container {
  width: 100%;
}

.json-key-value-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
  gap: 8px;
}

.json-key-input {
  width: 120px;
  flex-shrink: 0;
}

.json-value-input {
  flex: 1;
}
</style>

<script>
import { getConfig, addConfig, updateConfig } from '@/api/system/config'
import WangEditorV5 from '@/components/Editor/WangEditorV5'
export default {
  name: 'CreateForm',
  props: {
    typeOptions: {
      type: Array,
      required: true,
    },
  },
  components: {
    WangEditorV5,
  },
  data() {
    return {
      submitLoading: false,
      showLoading: false,
      formTitle: '',
      configTypeOptions: [
        { value: '1', label: '输入框' },
        { value: '2', label: '文本框' },
        { value: '3', label: '富文本' },
        { value: '4', label: 'json格式' },
      ],
      // 表单参数
      form: {
        id: undefined,
        configName: undefined,
        configGroup: undefined,
        configKey: undefined,
        configValue: '',
        configSystem: 'Y',
        configType: '1',
        remark: undefined,
      },
      open: false,
      jsonKeyValuePairs: [{ key: '', value: '' }], // JSON格式的键值对数组
      rules: {
        configName: [{ required: true, message: '参数名称不能为空', trigger: 'blur' }],
        configGroup: [{ required: true, message: '参数名称不能为空', trigger: 'blur' }],
        configKey: [{ required: true, message: '参数键名不能为空', trigger: 'blur' }],
        configValue: [
          {
            validator: (rule, value, callback) => {
              // 如果是json格式，验证键值对数组
              if (this.form.configType === '4') {
                const hasValidPair = this.jsonKeyValuePairs.some((item) => item.key && item.key.trim())
                if (!hasValidPair) {
                  callback(new Error('请至少添加一个有效的键值对'))
                } else {
                  callback()
                }
              } else {
                // 其他格式，验证configValue是否为空
                if (!value || (typeof value === 'string' && !value.trim())) {
                  callback(new Error('参数键值不能为空'))
                } else {
                  callback()
                }
              }
            },
            trigger: 'blur',
          },
        ],
      },
    }
  },
  filters: {},
  created() {},
  computed: {},
  watch: {
    'form.configType'(newVal) {
      // 当切换到json格式时，初始化键值对数组
      if (newVal === '4') {
        if (!this.jsonKeyValuePairs || this.jsonKeyValuePairs.length === 0) {
          this.jsonKeyValuePairs = [{ key: '', value: '' }]
        }
        // 如果已有configValue且是json格式，尝试解析
        if (this.form.configValue) {
          try {
            const parsed = JSON.parse(this.form.configValue)
            if (typeof parsed === 'object' && parsed !== null && !Array.isArray(parsed)) {
              this.jsonKeyValuePairs = Object.keys(parsed).map((key) => ({
                key,
                value: parsed[key],
              }))
              if (this.jsonKeyValuePairs.length === 0) {
                this.jsonKeyValuePairs = [{ key: '', value: '' }]
              }
            }
          } catch (e) {
            // 解析失败，使用默认值
            this.jsonKeyValuePairs = [{ key: '', value: '' }]
          }
        }
      } else {
        // 切换到其他格式时，清空键值对数组
        this.jsonKeyValuePairs = [{ key: '', value: '' }]
      }
    },
    // 监听键值对数组变化，触发configValue字段验证
    jsonKeyValuePairs: {
      handler() {
        if (this.form.configType === '4' && this.$refs.form) {
          this.$refs.form.validateField('configValue')
        }
      },
      deep: true,
    },
  },
  methods: {
    onClose() {
      this.open = false
    },
    // 取消按钮
    cancel() {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset() {
      this.form = {
        id: undefined,
        configName: undefined,
        configGroup: undefined,
        configKey: undefined,
        configValue: '',
        configSystem: 'Y',
        configType: '1',
        remark: undefined,
      }
      this.jsonKeyValuePairs = [{ key: '', value: '' }]
    },
    /** 新增按钮操作 */
    handleAdd() {
      this.reset()
      this.open = true
      this.formTitle = '添加参数'
    },
    /** 修改按钮操作 */
    handleUpdate(row, ids) {
      this.reset()
      const configId = row ? row.id : ids
      // 先打开 drawer，确保 LoadingPop 组件已渲染
      this.open = true
      this.formTitle = '修改参数'
      // 显示加载动画
      this.showLoading = true
      this.$nextTick(() => {
        if (this.$refs.LoadingPop) {
          this.$refs.LoadingPop.init(1)
        }
      })
      getConfig(configId)
        .then((response) => {
          this.form = response.data
          // 如果是json格式，解析configValue为键值对数组
          if (this.form.configType === '4' && this.form.configValue) {
            try {
              const parsed = JSON.parse(this.form.configValue)
              if (typeof parsed === 'object' && parsed !== null && !Array.isArray(parsed)) {
                this.jsonKeyValuePairs = Object.keys(parsed).map((key) => ({
                  key,
                  value: parsed[key],
                }))
                if (this.jsonKeyValuePairs.length === 0) {
                  this.jsonKeyValuePairs = [{ key: '', value: '' }]
                }
              } else {
                this.jsonKeyValuePairs = [{ key: '', value: '' }]
              }
            } catch (e) {
              this.jsonKeyValuePairs = [{ key: '', value: '' }]
            }
          }
        })
        .finally(() => {
          this.showLoading = false
        })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate((valid, object) => {
        if (valid) {
          // 创建提交表单数据的副本
          const submitForm = { ...this.form }

          // 如果参数类型是json格式，将键值对数组转换为JSON字符串格式传递给后端
          if (submitForm.configType === '4') {
            const jsonObj = {}
            this.jsonKeyValuePairs.forEach((item) => {
              if (item.key && item.key.trim()) {
                jsonObj[item.key.trim()] = item.value || ''
              }
            })
            // 将对象转换为JSON字符串
            submitForm.configValue = JSON.stringify(jsonObj)
            // 验证至少有一个有效的键值对
            if (Object.keys(jsonObj).length === 0) {
              this.$message.warning('请至少添加一个有效的键值对', 3)
              return false
            }
          }
          this.submitLoading = true
          this.showLoading = true
          this.$nextTick(() => {
            this.$refs.LoadingPop.init(1)
          })
          if (submitForm.id !== undefined) {
            updateConfig(submitForm)
              .then((response) => {
                this.$message.success('修改成功', 3)
                this.open = false
                this.$emit('ok')
              })
              .finally(() => {
                this.submitLoading = false
                this.showLoading = false
              })
          } else {
            addConfig(submitForm)
              .then((response) => {
                this.$message.success('新增成功', 3)
                this.open = false
                this.$emit('ok')
              })
              .finally(() => {
                this.submitLoading = false
                this.showLoading = false
              })
          }
        } else {
          const messages = Object.values(object).flatMap((errorArray) => errorArray.map((item) => item.message))
          this.showLoading = true
          this.$nextTick(() => {
            this.$refs.LoadingPop.init(2, messages)
          })
          return false
        }
      })
    },
    // 添加键值对
    addKeyValuePair() {
      this.jsonKeyValuePairs.push({ key: '', value: '' })
    },
    // 删除键值对
    removeKeyValuePair(index) {
      if (this.jsonKeyValuePairs.length > 1) {
        this.jsonKeyValuePairs.splice(index, 1)
      }
    },
  },
}
</script>
